import en from './translations/en.json';
import es from './translations/es.json';

// If we add more than just spanish, just import the files and export it below:
// export default { en, es, de }
export default { en, es };
